<template>
  <common-card>
    <v-toolbar color="primary" dense dark flat>
      <v-toolbar-title>
        <span class="font-montserrat font-weight-bold">
          Reporte Familiares / Beneficiarios
        </span>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col md="3">
          <v-select
            label="Seleccionar Alianza"
            :items="alianzas"
            item-text="nombre"
            item-value="id"
            v-model="alianza"
            outlined
            class="mt-5"
          />

          <v-radio-group v-model="modo" row>
            <v-radio label="Rango de fechas" value="rango" />
            <v-radio label="General" value="general" />
          </v-radio-group>

          <v-date-picker
            v-if="modo === 'rango'"
            v-model="dates"
            range
            :allowed-dates="validarFecha"
            locale="es"
          />

          <v-btn
            block
            color="primary"
            dark
            :disabled="!puedeEjecutar"
            class="mt-4"
            @click="consultar"
          >
            Ejecutar Reporte
          </v-btn>

          <v-btn
            block
            class="mt-3"
            color="success"
            :disabled="reportDownload.length === 0"
            @click="descargarCSV"
          >
            Descargar
          </v-btn>
        </v-col>

        <v-col md="9">
          <v-data-table
            :headers="columns"
            :items="polizas"
            class="elevation-1"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import moment from "moment";
import { getAlianzas } from "@/services/alianzas/alianzas.service.js";
import { obtenerReporteFamiliares, descargarReporteFamiliaresCSV } from "@/services/emision/emision.service";

export default {
  components: {
    CommonCard,
  },
  data() {
    return {
      alianza: null,
      alianzas: [],
      modo: "rango",
      dates: [],
      polizas: [],
      reportDownload: [],
      columns: [
        { text: "Num. Socio", value: "num_socio" },
        { text: "Nombre Titular", value: "nombre_titular" },
        { text: "Apellido Paterno", value: "apellido_paterno" },
        { text: "Apellido Materno", value: "apellido_materno" },
        { text: "Status", value: "status" },
        { text: "Nombre Familiar", value: "nombre_familiar" },
        { text: "Parentesco", value: "parentesco" },
        { text: "Es Beneficiario", value: "es_beneficiario" },
        { text: "Porcentaje", value: "porcentaje" }
      ],
    };
  },
  computed: {
    puedeEjecutar() {
      return (
        this.alianza &&
        (this.modo === "general" ||
          (this.modo === "rango" &&
            this.dates.length === 2 &&
            this.validarFecha(this.dates[0])))
      );
    },
  },
  watch: {
    //Se limpia todo al cambiar modo
    modo(nuevoModo) {
      this.polizas = [];
      this.reportDownload = [];
      if (nuevoModo === "general") {
        this.dates = [];
      }
    },
    //Se limpia todo al cambiar alianza
    alianza() {
      this.polizas = [];
      this.reportDownload = [];
      },
  },
  methods: {
    validarFecha(fecha) {
      const fechaLimite = moment().subtract(2, "months").startOf("day");
      return moment(fecha).isSameOrAfter(fechaLimite);
    },

    async obtenerAlianzas() {
      try {
        this.alianzas = await getAlianzas();
      } catch (err) {
        console.error("Error al obtener alianzas:", err);
      }
    },

    async consultar() {
      const body = {
        alianzaId: String(this.alianza),
      };

      if (this.modo === "rango" && this.dates.length === 2) {
        const inicio = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
        const fin = moment
          .utc(this.dates[1])
          .add(24, "hours")
          .subtract(1, "seconds")
          .format("YYYY-MM-DD HH:mm:ss");

        body.fechaInicio = inicio;
        body.fechaFin = fin;
      }

      try {
        const data = await obtenerReporteFamiliares(body);
        this.polizas = [];
        this.reportDownload = [];

        data.forEach((el) => {
          const registro = {
            num_socio: el.num_socio,
            nombre_titular: el.nombre,
            apellido_paterno: el.apellidoPaterno,
            apellido_materno: el.apellidoMaterno,
            status: el.statusEtiqueta || "Desconocido",
            nombre_familiar: el.nombre_familiar,
            estado_civil: el.estadoCivil,
            edad: el.edad,
            parentesco: el.parentesco || "Aún sin llenar",
            es_beneficiario: el.es_beneficiario ? "Sí" : "No",
            porcentaje: el.porcentaje + "%",
          };
          this.polizas.push(registro);
          this.reportDownload.push(registro);
        });
      } catch (err) {
        console.error("Error al consultar el reporte:", err);
      }
    },

    async descargarCSV() {
      const body = {
        alianzaId: this.alianza,
      };

      if (this.modo === "rango" && this.dates.length === 2) {
        const inicio = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
        const fin = moment
          .utc(this.dates[1])
          .add(24, "hours")
          .subtract(1, "seconds")
          .format("YYYY-MM-DD HH:mm:ss");

        body.fechaInicio = inicio;
        body.fechaFin = fin;
      }

      try {
        const data = await descargarReporteFamiliaresCSV(body);

        const blob = new Blob([data], {
          type: "application/csv;charset=utf-8;",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Reporte_Familiares_Beneficiarios.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        console.error("Error al descargar CSV:", err);
      }
    },

  },
  mounted() {
    this.obtenerAlianzas();
  },
};
</script>
